import type { ReactNode } from "react";

import type { DesignSystemElementProps, DesignSystemRef } from "./contracts/dom";

type ErrorStateProps = {
  title: string;
  status: string;
  errorLabel: string;
  solutions: ReactNode[];
  solutionsLabel?: string;
  illustration: string;
  extraInfo?: string;
} & Omit<DesignSystemElementProps<"div">, "children"> &
  DesignSystemRef<HTMLDivElement>;

export function ErrorState({
  title,
  status,
  errorLabel,
  solutions,
  solutionsLabel,
  illustration,
  extraInfo,
  ref,
  ...nativeProps
}: ErrorStateProps): ReactNode {
  return (
    <div {...nativeProps} ref={ref} className="@container h-full">
      <div className="flex h-full flex-col flex-wrap items-center justify-center p-space-xl @sm:flex-row">
        <div className="mt-space-xl flex flex-col justify-center text-left @sm:mt-0">
          <span className="text-heading-2 whitespace-pre-wrap">{title}</span>
          {!extraInfo && (
            <p
              className="mt-space-xs max-w-error-state-copy text-text-secondary"
              data-testid="error-page-status"
            >{`${errorLabel} ${status}`}</p>
          )}

          {extraInfo && <p className="mt-space-xs max-w-error-state-copy text-text-secondary">{extraInfo}</p>}

          {solutionsLabel && (
            <span className="mt-error-state-solutions mb-space-xs text-body-emphasis">{solutionsLabel}</span>
          )}
          <ul className="list-disc pl-space-xl">
            {solutions.map((solution, index) => (
              <li className="py-space-sm whitespace-pre text-text-secondary" key={`error_solution_${index}`}>
                {solution}
              </li>
            ))}
          </ul>
        </div>
        <img
          className="w-error-state-illustration-compact pt-space-xl @sm:ml-error-state-illustration-gap @sm:w-error-state-illustration-wide"
          src={illustration}
          alt=""
        />
      </div>
    </div>
  );
}
